import { ILead } from '../entities/ILead';
import { LeadLostReasonEnum } from '../enums/LeadLostReasonEnum';
import { LeadReviewStatusEnum } from '../enums/LeadReviewStatusEnum';
import { LeadSourceEnum } from '../enums/LeadSourceEnum';
import { httpClient } from './helper/httpClient';

export interface ICreateLeadParams {
  name: string;
  email: string;
  phone?: string;
  instagram?: string;
  notes?: string;
  source?: LeadSourceEnum;
  expectedBirthDate?: string | null;
  referrerId?: string;
}

export interface IUpdateLeadParams {
  name?: string;
  email?: string;
  phone?: string;
  instagram?: string;
  notes?: string;
  source?: LeadSourceEnum;
  lostReason?: LeadLostReasonEnum;
  lostReasonNote?: string;
  reviewStatus?: LeadReviewStatusEnum;
  expectedBirthDate?: string | null;
  referrerId?: string | null;
}

class LeadService {
  private _baseURL = 'leads';

  create(data: ICreateLeadParams): Promise<ILead> {
    return httpClient.post<null, ILead>(`${this._baseURL}`, {
      ...data,
      active: true,
    });
  }

  getAll(): Promise<ILead[]> {
    return httpClient.get<null, ILead[]>(`${this._baseURL}`);
  }

  getById(id: string): Promise<ILead> {
    return httpClient.get<null, ILead>(`${this._baseURL}/${id}`);
  }

  updateStatus(id: string, value: boolean): Promise<void> {
    return httpClient.patch(`${this._baseURL}/${id}`, {
      active: value,
    });
  }

  update(id: string, data: IUpdateLeadParams): Promise<void> {
    return httpClient.patch(`${this._baseURL}/${id}`, {
      ...data,
    });
  }
}

export default new LeadService();
